<div class="container">
    <div class="row mb-3">
                <div class="col-md-12" *ngIf="portalSettings['PortalWelcomeText'].ConfigValue != null && portalSettings['PortalWelcomeText'].ConfigValue != ''" [hidden]="lastLogonDate == null  || lastLogonDate == ''">
                    <h3>{{welcomeMsg}}</h3>
                    <span>Your last login to the portal was on {{lastLogonDate}}</span>
                </div>
                <div class="col-md-12" *ngIf="portalSettings['PortalWelcomeText'].ConfigValue == null || portalSettings['PortalWelcomeText'].ConfigValue == ''" [hidden]="lastLogonDate == null || lastLogonDate == ''">
                    <h3>Welcome back to the portal, {{employeeInfo.FirstName}}.</h3>
                    <span>Your last login to the portal was on {{lastLogonDate}}</span>
                </div>
                <div class="col-md-12" *ngIf="portalSettings['PortalWelcomeText'].ConfigValue == null || portalSettings['PortalWelcomeText'].ConfigValue == ''" [hidden]="lastLogonDate != null || lastLogonDate != ''">
                    <h3>Welcome to the portal, {{employeeInfo.FirstName}}.</h3>
                    <span>This is your first log in to the portal!</span>
                </div>
                <div class="col-md-12" *ngIf="employeeInfo.LoginType != 'Identity' && employeeInfo.PasswordResetStatus != null && employeeInfo.PasswordResetStatus <= passwordResetWarningDays">
                    <span>Your password will expire in {{employeeInfo.PasswordResetStatus}} days.</span>
                    <a href="/Account/ChangeAccountPassword"> Please click here to update your password.</a>
                </div>
    </div>
    <div class="card mb-3" style="border-left: 41px solid; border-color: #c81922; border-top-width: 1px; border-bottom-width: 1px; border-right-width: 1px; cursor:pointer;" (click)="routeToDocLibrary()" *ngIf="!IsTermLock && alert && showBulletinAlert">
        <div class="card-body">
            <h3 style="margin-top: 10px; margin-bottom: 10px;" class="alert-danger"><i style="margin-right: 10px; vertical-align: text-bottom;" class="modus-icons" aria-hidden="true">paper_plane</i>{{alert.msg}}</h3>
        </div>
    </div>

    <div class="card mb-3" style="border-left: 41px solid; border-color: #005f9e; border-top-width: 1px; border-bottom-width: 1px; border-right-width: 1px;" *ngIf="performanceAlert || performanceManAlert">
        <div class="card-body">
            <div class="alert-primary" style="font-size:18px; font-weight:500; margin-top:10px; display:inline;">
                <i style="vertical-align: text-bottom; margin-right: 10px;" class="modus-icons">list_bulleted</i>
                <a (click)="routeToForm()" style="cursor:pointer;">{{performanceAlert?.msg}}</a>
                <a (click)="routeToManForm()" style="cursor:pointer;">{{performanceManAlert?.msg}}</a>
            </div>
        </div>
    </div>

    <div id="hotlistItems" class="card border border-light shadow mb-3">
        <div class="card-header bg-light">
            <h4 class="thinner">
                My Hotlist Items <span class="float-right" (click)="editHotList()" style="cursor:pointer;" *ngIf="moduleCategories?.length != 0"><a href="#"><span *ngIf="!mobileMode">Manage My Hotlist</span>  <i style="vertical-align: text-bottom; margin-left: 5px;" class="modus-icons">gear</i></a></span>
            </h4>
        </div>
        <div class="hotlistItems card-body">
            <ul>
                <li *ngFor="let module of hotlistItems"
                    (click)="goToModule(module)">
                    <i class="modus-icons hotlistIcon" *ngIf="module.ModuleAngularIcon != null">{{module.ModuleAngularIcon}}</i>
                    <i class="modus-icons hotlistIcon" *ngIf="module.ModuleAngularIcon == null">list_bulleted</i>
                    <h4 class="hotlistText">{{module.ModulePrettyShortName}}</h4>
                </li>
            </ul>
        </div>

    </div>
    <div class="card border border-light shadow mb-3" *ngIf="bulletinsEnabled && bulletins?.length > 0 && !IsTermLock">
        <div class="card-header bg-light">
            <h4 class="thinner">
                Announcements
            </h4>
        </div>
        <div class="card-body">
            <div class="d-none d-sm-block">
                <div class="row" style="margin-left:10px">
                    <ng-container *ngFor="let bulletin of bulletins; let bulletinIndex = index">
                        <div class="row col-xl-6 col-lg-6 col-md-12" style="margin-bottom:25px; max-height:800px;margin-right:15px">
                            <div class="col-xl-4 col-lg-4 col-md-4 col-sm-6"
                                 *ngIf="bulletin.BulletinThumbFileAttachmentID != null">
                                <a href="/Home/Bulletin/{{bulletin.BulletinID}}">
                                    <img class="img-fluid" style="max-height:125px;"
                                         src="/Document/GetDBAttachment?attachmentID={{bulletin.BulletinThumbFileAttachmentID}}" />
                                </a>
                            </div>
                            <div [ngClass]="{'col-xl-8 col-lg-8 col-md-8 col-sm-6': bulletin.BulletinThumbFileAttachmentID != null}" style="margin-bottom:15px;">
                                <b>{{bulletin.BulletinHeadline}}</b>
                                <p class="announcement-text">{{bulletin.BulletinThumbnailText}}</p>
                                <a href="/Home/Bulletin/{{bulletin.BulletinID}}">Read more...</a>
                            </div>
                        </div>

                        <div class="clearfix d-none d-sm-block" *ngIf="bulletinIndex % 2 == 1">
                        </div>
                    </ng-container>
                </div>
            </div>
            <!-- Mobile View -->
            <div class="d-block d-sm-none col-sm-12">
                <div *ngFor="let bulletin of bulletins; last as isLast" [ngClass]="{'border-bottom':!isLast}" class="row mobile-announcement">
                    <div class="col-sm-12" *ngIf="bulletin.BulletinThumbFileAttachmentID != null">
                        <img class="img-fluid" style="max-height:175px; margin-bottom:10px;"
                             src="/Document/GetDBAttachment?attachmentID={{bulletin.BulletinThumbFileAttachmentID}}" />
                    </div>

                    <div [ngClass]="{'col-sm-12': bulletin.BulletinThumbFileAttachmentID != null}" style="margin-bottom:15px;">
                        <b>{{bulletin.BulletinHeadline}}</b>
                        <p>{{bulletin.BulletinThumbnailText}}</p>
                        <a href="/Home/Bulletin/{{bulletin.BulletinID}}">Read more...</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
